import { rgba } from "polished";
import { breakpoints } from "./breakpoints";

const defaultColors = {
  primary: "#FFFFFF",
  secondary: "#111111",
  white: "#FFFFFF",
  dark: "#000000",
  ash: "#999999",
  black: "#000000",
  warning: "#D4A843",
  success: "#4A9E5C",
  info: "#5B9BF6",
};

const colors = {
  primary: defaultColors.primary,
  secondary: defaultColors.secondary,
  light: defaultColors.white,
  lightShade: rgba(defaultColors.white, 0.5),
  dark: defaultColors.dark,
  darkShade: rgba(defaultColors.dark, 0.5),
  ash: defaultColors.ash,
  bg: defaultColors.dark,
  bgShade: rgba(defaultColors.dark, 0.5),
  front: defaultColors.white,
  frontShade: rgba(defaultColors.white, 0.5),
  border: "rgba(255,255,255,0.08)",
  shadow: "rgba(0,0,0,0)",
  heading: defaultColors.white,
  text: rgba(defaultColors.white, 0.6),
  warning: defaultColors.warning,
  success: defaultColors.success,
  info: defaultColors.info,

  modes: {
    dark: {
      primary: defaultColors.white,
      secondary: defaultColors.secondary,
      light: defaultColors.white,
      lightShade: rgba(defaultColors.white, 0.5),
      dark: defaultColors.dark,
      darkShade: rgba(defaultColors.dark, 0.5),
      ash: defaultColors.ash,
      bg: defaultColors.dark,
      bgShade: rgba(defaultColors.dark, 0.5),
      front: defaultColors.white,
      frontShade: rgba(defaultColors.white, 0.5),
      border: "rgba(255,255,255,0.08)",
      shadow: "rgba(0,0,0,0)",
      heading: defaultColors.white,
      text: rgba(defaultColors.white, 0.6),
      warning: defaultColors.warning,
      success: defaultColors.success,
      info: defaultColors.info,
    },
  },
};

const theme = {
  initialColorModeName: "dark",
  colors: colors,
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  breakpoints: [
    `${breakpoints.sm}px`,
    `${breakpoints.md}px`,
    `${breakpoints.lg}px`,
    `${breakpoints.xl}px`,
  ],
};

export default theme;
